import {
  GoogleLogin,
  GoogleLoginProps,
  GoogleOAuthProvider,
} from '@react-oauth/google';

import { GOOGLE_CLIENT_ID } from '@/shared/config';

export type { CredentialResponse } from '@react-oauth/google';

export default function GoogleOauthButton(props: GoogleLoginProps) {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GoogleLogin {...props} />
    </GoogleOAuthProvider>
  );
}
